import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "hide" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "set-column" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "列表显示设置")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("序号")

import { onMounted, ref, unref } from "vue";
import { VxeTableInstance } from "vxe-table";
import { TableListService, TitleParamReq } from "./table-list.service";

export default /*#__PURE__*/_defineComponent({
  __name: 'editableCell',
  props: {
    columns: { default: () => [] },
    xTable: { default: null },
    tabeleBizCode: { default: "" }
  },
  emits: ["changeColumns"],
  setup(__props: any, { emit: emits }) {

const props = __props as { columns: Array<any>, xTable: VxeTableInstance | null, tabeleBizCode: string }



let columnsFillter = ref<string[]>([]);
let saveValue: Array<TitleParamReq> = [];
const { run: getColumns, data: columnsData } = TableListService.useGetColumnsApi();
const { run: changeColumns } = TableListService.useChangeColumnsApi();
const confirms = () => {
  saveValue = [];

  props.columns.map((e) => {
    !e["key"] && (e["key"] = e["dataIndex"]);

    if (e["children"] && e["children"].length > 0) {
      e["isShow"] = false;
      e["children"].map((v) => {
        !v["key"] && (v["key"] = v["dataIndex"]);
        v["isShow"] = columnsFillter.value.includes((v.key ? v.key : v.dataIndex) as string);
        v["isShow"] && (e["isShow"] = true);
        v["isShow"] &&
          saveValue.push({
            attributeValue: v.key,
            name: v["title"],
          });
      });
    } else {
      e["isShow"] = columnsFillter.value.includes((e.key ? e.key : e.dataIndex) as string);
      e["isShow"] &&
        saveValue.push({
          attributeValue: e.key,
          name: e["title"],
        });
    }
  });

  saveColumns();
  (props.xTable as any).refreshColumn();
  emits("changeColumns", saveValue);
};
const loadColumnFillter = () => {
  let storageColumns: any = null;
  if (unref(columnsData) && unref(columnsData)?.titleParamReqs) {
    // // console.log(
    //   "🚀 ~ file: editableCell.vue ~ line 80 ~ loadColumnFillter ~ columnsData",
    //   unref(columnsData)
    // );
    storageColumns = [];
    unref(columnsData)?.titleParamReqs?.map((c) => {
      storageColumns.push(c.attributeValue);
    });
  }
  if (!storageColumns) {
    props.columns.map((e) => {
      !e["key"] && (e["key"] = e["dataIndex"]);
      if (e["children"] && e["children"].length > 0) {
        e["children"].map((v) => {
          !v["key"] && (v["key"] = v["dataIndex"]);

          !(v["isShow"] === false) &&
            columnsFillter.value.push((v.key ? v.key : v.dataIndex) as string);
          !(v["isShow"] === false) &&
            saveValue.push({
              attributeValue: v.key,
              name: v["title"],
            });
        });
      } else {
        !(e["isShow"] === false) &&
          columnsFillter.value.push((e.key ? e.key : e.dataIndex) as string);
        !(e["isShow"] === false) &&
          saveValue.push({
            attributeValue: e.key,
            name: e["title"],
          });
      }
    });
  } else {
    columnsFillter.value = storageColumns;
    props.columns.map((e) => {
      !e["key"] && (e["key"] = e["dataIndex"]);
      if (e["children"] && e["children"].length > 0) {
        e["isShow"] = false;
        e["children"].map((v) => {
          !v["key"] && (v["key"] = v["dataIndex"]);
          v["isShow"] = columnsFillter.value.includes((v.key ? v.key : v.dataIndex) as string);
          v["isShow"] && (e["isShow"] = true);
          v["isShow"] &&
            saveValue.push({
              attributeValue: v.key,
              name: v["title"],
            });
        });
      } else {
        e["isShow"] = columnsFillter.value.includes((e.key ? e.key : e.dataIndex) as string);
        e["isShow"] &&
          saveValue.push({
            attributeValue: e.key,
            name: e["title"],
          });
      }
    });
  }

  emits("changeColumns", saveValue);
};
const saveColumns = () => {
  props.tabeleBizCode != "" &&
    changeColumns({
      bizType: props.tabeleBizCode,
      titleParamReqs: saveValue,
    });
};
onMounted(async () => {
  if (props.tabeleBizCode != "") {
    await getColumns({ bizType: props.tabeleBizCode });
  }
  loadColumnFillter();
  // console.log(props.columns, columnsFillter);
});

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createBlock(_component_a_popconfirm, {
    class: "append-to-body",
    overlayClassName: "table-column-set",
    placement: "bottomLeft",
    "ok-text": "确认",
    "cancel-text": "取消",
    onConfirm: _withModifiers(confirms, ["stop"])
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _hoisted_2,
      _createVNode(_component_a_checkbox, {
        style: {"width":"150px"},
        checked: true,
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_a_tree, {
        checkable: "",
        defaultExpandAll: "",
        class: "not-switcher-icon",
        selectable: false,
        checkedKeys: _unref(columnsFillter),
        "onUpdate:checkedKeys": _cache[0] || (_cache[0] = ($event: any) => (_isRef(columnsFillter) ? (columnsFillter).value = $event : columnsFillter = $event)),
        "tree-data": __props.columns
      }, null, 8, ["checkedKeys", "tree-data"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "link",
        class: "setting-btn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ant_icon, { type: "SettingOutlined" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onConfirm"]))
}
}

})